import { IllustrationCards } from './IllustrationCards'

import type { IllustrationCardProps } from './IllustrationCard'
import type { SanityContentLinkCards } from 'src/types/HomepageContent'

export const LinkCards = ({ title, linkCards }: SanityContentLinkCards) => {
  const bannerHeadLineText = title

  const names = ['espresso-machine', 'filter-grinder', 'hand-grinder', 'filter-coffee'] as const

  const cards: IllustrationCardProps[] = names.map((name, index) => {
    const card = linkCards[index]
    return {
      name,
      headlineText: card?.cardTitle || '',
      href: card?.cardLink || '#',
    }
  })

  return <IllustrationCards cards={cards} bannerHeadLineText={bannerHeadLineText} styledCards />
}
